<div class="critical-alerts" *transloco="let t; prefix: 'maintenanceOverview.criticalAlerts'">
  <h3 class="critical-alerts__title">{{ t('title') }}</h3>

  @if (isLoading && page === 1) {
    <div class="critical-alerts__loading">
      <span class="spinner-border"></span>
    </div>
  } @else if (hasError) {
    <div class="critical-alerts__empty">
      <app-error-state></app-error-state>
    </div>
  } @else if (alerts.length === 0) {
    <div class="critical-alerts__empty">
      <app-empty-state [message]="t('empty')"></app-empty-state>
    </div>
  } @else {
    <div
      class="critical-alerts__list"
      infiniteScroll
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="300">
      @for (alert of alerts; track $index) {
        <div class="alert-card">
          <div class="alert-card__header">
            <div class="alert-card__info">
              <span class="alert-card__asset-name" [title]="alert.assetName">{{ alert.assetName }}</span>
              <span class="alert-card__assigned" [title]="formatAssignedTo(alert)" [class.alert-card__assigned--unassigned]="!hasAssignedTechnician(alert)">
                {{ formatAssignedTo(alert) }}
              </span>
            </div>
            <span class="alert-card__due-badge" [class.alert-card__due-badge--upcoming]="alert.due >= 0">
              {{ formatDue(alert.due) }}
            </span>
          </div>
          @if (alert.serviceType) {
            <div class="alert-card__service-type">
              {{ formatMaintenanceReason(alert) }}
            </div>
          }
        </div>
      }

      @if (page > 1 && isLoading) {
        <div class="critical-alerts__loading-more d-flex justify-content-center py-2">
          <span class="spinner-border spinner-border-sm"></span>
        </div>
      }
    </div>
  }
</div>